<script lang="ts">
	import imageDrinkCoffeeAtTable3xl from "@assets/images/drinking-coffee-at-table.jpg?webp&imagetools";
	import imageDrinkCoffeeAtTableXs from "@assets/images/drinking-coffee-at-table.jpg?webp&w=640&imagetools";
	import imageDrinkCoffeeAtTableSm from "@assets/images/drinking-coffee-at-table.jpg?webp&w=768&imagetools";
	import imageDrinkCoffeeAtTableMd from "@assets/images/drinking-coffee-at-table.jpg?webp&w=1024&imagetools";
	import imageDrinkCoffeeAtTableLg from "@assets/images/drinking-coffee-at-table.jpg?webp&w=1280&imagetools";
	import imageDrinkCoffeeAtTableXl from "@assets/images/drinking-coffee-at-table.jpg?webp&w=1536&imagetools";
	import imageDrinkCoffeeAtTable2Xl from "@assets/images/drinking-coffee-at-table.jpg?webp&w=1920&imagetools";
	import heroImageXs from "@assets/images/partnership-hero.jpg?webp&h=1000&quality=90&imagetools";
	import heroImageSm from "@assets/images/partnership-hero.jpg?webp&h=1600&quality=90&imagetools";
	import heroImageLg from "@assets/images/partnership-hero.jpg?webp&h=2200&imagetools";
	import heroImageXl from "@assets/images/partnership-hero.jpg?webp&h=2800&imagetools";
	import heroImage2Xl from "@assets/images/partnership-hero.jpg?webp&imagetools";
	import imageHanzXs from "@assets/images/team/hanz.jpg?webp&w=640&imagetools";
	import imageHanzMd from "@assets/images/team/hanz.jpg?webp&w=1024&imagetools";
	import imageHanzXl from "@assets/images/team/hanz.jpg?webp&w=1536&imagetools";
	import imageMarieKXs from "@assets/images/team/marie-k.jpg?webp&w=640&imagetools";
	import imageMarieKMd from "@assets/images/team/marie-k.jpg?webp&w=1024&imagetools";
	import imageMarieKXl from "@assets/images/team/marie-k.jpg?webp&w=1536&imagetools";
	import imageOndrejXs from "@assets/images/team/ondrej.jpg?webp&w=640&imagetools";
	import imageOndrejMd from "@assets/images/team/ondrej.jpg?webp&w=1024&imagetools";
	import imageOndrejXl from "@assets/images/team/ondrej.jpg?webp&w=1536&imagetools";
	import imageTerkaXs from "@assets/images/team/terka.jpg?webp&w=640&imagetools";
	import imageTerkaMd from "@assets/images/team/terka.jpg?webp&w=1024&imagetools";
	import imageTerkaXl from "@assets/images/team/terka.jpg?webp&w=1536&imagetools";
	import berriesImageSm from "@assets/images/wholesale-berries.jpg?webp&h=800&imagetools";
	import berriesImageMd from "@assets/images/wholesale-berries.jpg?webp&h=1100&imagetools";
	import berriesImageLg from "@assets/images/wholesale-berries.jpg?webp&h=1300&imagetools";
	import berriesImageXl from "@assets/images/wholesale-berries.jpg?webp&imagetools";
	import ContactForm from "@components/ContactForm.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import StructuredData from "@components/common/StructuredData.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import WholesalePartners from "@components/wholesale/WholesalePartners.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { WebMessageType } from "@core/schema/WebMessageType.js";
	import { getJoinWholesaleAnchor } from "@core/schema/paths/getJoinWholesaleAnchor.js";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";
	import { formatPhoneNumber } from "@core/utils/formatPhoneNumber.js";
	import { nbsp } from "@core/utils/unicodes/nbsp.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import { SeoFragment } from "../seo/SeoFragment.js";
	import { idRef, seoId } from "../seo/seoIds.js";
	import translations from "./Wholesale.translations.json" with { type: "json" };
	import type { WholesaleProps } from "./WholesaleProps.js";

	const { tenant }: WholesaleProps = $props();
	const { WEB_URL_OR_LOCAL } = getGlobalSettings();
	const translate = getTranslate(translations);

	const organizationRef = idRef(seoId(WEB_URL_OR_LOCAL, SeoFragment.Organization));

	const emailSuffix = "@fathers.cz";
	const wholesaleTeam = [
		{
			name: "Ondrej",
			jobTitle: translate("ondrejJobTitle"),
			email: `ondrej${emailSuffix}`,
			tel: formatPhoneNumber("+420 739 892 940"),
			image: {
				default: imageOndrejXs,
				">md": imageOndrejMd,
				">xl": imageOndrejXl,
			},
		},
		{
			name: "Terka",
			jobTitle: translate("terkaJobTitle"),
			email: `tereza.k${emailSuffix}`,
			tel: formatPhoneNumber("+420 777 274 206"),
			image: {
				default: imageTerkaXs,
				">md": imageTerkaMd,
				">xl": imageTerkaXl,
			},
		},
		{
			name: "Honza",
			jobTitle: translate("hanzJobTitle"),
			email: `jan${emailSuffix}`,
			tel: formatPhoneNumber("+420 775 408 990"),
			image: {
				default: imageHanzXs,
				">md": imageHanzMd,
				">xl": imageHanzXl,
			},
		},
		{
			name: "Marie",
			jobTitle: translate("marieJobTitle"),
			email: `wholesale${emailSuffix}`,
			tel: formatPhoneNumber("+420 604 164 580"),
			image: {
				default: imageMarieKXs,
				">md": imageMarieKMd,
				">xl": imageMarieKXl,
			},
		},
	];
</script>

<Layout transparentHeader>
	<section class={["full-width overflow-hidden relative h-screen md:h-screen"]}>
		<div
			class="flex flex-col items-center mx-auto justify-center z-30 pb-[max(env(safe-area-inset-bottom,0),2.5rem)] inset-0 absolute pt-10 md:py-20"
		>
			<div class="max-w-full flex flex-col gap-2 sm:gap-4 justify-self-center text-center">
				<div class="font-antipol text-white text-10/tighter md:text-15/tighter font-medium">
					<Heading level={1} text={translate("heroHeading")} />
				</div>
				<div class="font-antipol text-white text-6/tighter md:text-8/tighter font-medium">
					<Formatted text={translate("heroParagraph")} />
				</div>
			</div>
		</div>
		<div class="absolute inset-0" aria-hidden="true">
			<div class={["absolute inset-0 bg-black/20 z-10"]}></div>
			<Media
				eager={true}
				preload="high"
				width={1920}
				height={1080}
				source={{ type: "image/webp", src: heroImageXs }}
				sourcesets={{
					">sm": heroImageSm,
					">lg": heroImageLg,
					">xl": heroImageXl,
					">2xl": heroImage2Xl,
				}}
				alt=""
				wrapperClass="overflow-hidden absolute inset-0"
				class={["absolute block inset-0 size-full object-cover"]}
			/>
		</div>
	</section>
	<section class="py-26" id={idFromAnchor(getJoinWholesaleAnchor(tenant.locale))}>
		<div class="grid lg:grid-cols-2 gap-15 lg:gap-29">
			<div class="text-lg/normal text-black mt-4 min-w-0">
				<Formatted text={translate("partnershipParagraph")} />

				<Media
					width={689}
					height={433}
					source={{ type: "webp", src: imageDrinkCoffeeAtTableXs }}
					sourcesets={{
						">sm": imageDrinkCoffeeAtTableSm,
						">md": imageDrinkCoffeeAtTableMd,
						">lg": imageDrinkCoffeeAtTableLg,
						">xl": imageDrinkCoffeeAtTableXl,
						">2xl": imageDrinkCoffeeAtTable2Xl,
						">3xl": imageDrinkCoffeeAtTable3xl,
					}}
					alt={translate("imgDrinkCoffeeAtTableAlt")}
					class="w-full h-108 object-cover mt-15 hidden lg:block"
				/>
			</div>
			<div class="min-w-0">
				<ContactForm type={WebMessageType.Wholesale} />
			</div>
		</div>
	</section>
	<section class="py-26 bg-fcrbeige full-width grid-container">
		<div class="text-fcrdarkgray font-medium font-antipol text-7/tight 2xs:text-8/tighter">
			<Heading level={2} text={translate("ourTeamTitle")} />
		</div>
		<div class="grid grid-cols-2 lg:grid-cols-4 gap-8 pt-10">
			{#each wholesaleTeam as member (member.email)}
				<StructuredData
					data={{
						"@type": "Person",
						name: member.name,
						jobTitle: member.jobTitle,
						email: member.email,
						telephone: member.tel,
						affiliation: organizationRef,
					}}
				/>
				<div class="flex flex-col gap-6">
					<Media
						width={200}
						height={100}
						source={{ type: "webp", src: member.image.default }}
						sourcesets={{
							">md": member.image[">md"],
							">xl": member.image[">xl"],
						}}
						alt={member.name}
						class="w-full"
					/>
					<div>
						<div class="text-fcrdarkgray font-antipol font-medium text-5.5/normal mb-2">
							<Formatted text={member.name} />
						</div>
						<div class="text-fcrdarkgray text-base/tight">
							<div><Formatted text={member.jobTitle} /></div>
							<div><Formatted text={member.email} /></div>
							<div><Formatted text={member.tel} /></div>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</section>
	<section class="py-26 full-width grid-container">
		<WholesalePartners />
	</section>
	<section class="py-26 bg-fcrbrown text-fcrbeige full-width grid-container">
		<div class="grid grid-cols-1 lg:grid-cols-3 gap-20">
			<div class="grid grid-rows-subgrid gap-7 row-span-2">
				<div class="font-antipol font-medium text-7/tighter"><Formatted text={translate("fastOrdersTitle")} /></div>
				<div class="text-lg"><Formatted text={translate("fastOrdersParagraph")} /></div>
			</div>
			<div class="grid grid-rows-subgrid gap-7 row-span-2">
				<div class="font-antipol font-medium text-7/tighter"><Formatted text={translate("qualityTitle")} /></div>
				<div class="text-lg"><Formatted text={translate("qualityParagraph")} /></div>
			</div>
			<div class="grid grid-rows-subgrid gap-7 row-span-2">
				<div class="font-antipol font-medium text-7/tighter"><Formatted text={translate("familyGrowTitle")} /></div>
				<div class="text-lg"><Formatted text={translate("familyGrowParagraph")} /></div>
			</div>
		</div>
	</section>
	<section class="h-30 md:h-50 overflow-hidden relative full-width">
		<div
			class="flex flex-col items-center mx-auto justify-between z-30 pb-[max(env(safe-area-inset-bottom,0),2.5rem)] inset-0 absolute pt-10 md:py-20"
		>
			<div class="flex flex-col text-center z-20">
				<Heading
					level={2}
					text={[
						translate("freeShipping"),
						translate("partnerPricing"),
						translate("individualApproach"),
						translate("customBrand"),
					].join(`${nbsp}|${nbsp}`)}
					class="text-white font-antipol text-4/tighter md:text-5/tighter lg:text-6/tighter xl:heading-2"
				/>
			</div>
			<div class="absolute inset-0" aria-hidden="true">
				<div class={["absolute inset-0 bg-black/20 z-10"]}></div>
				<Media
					width={1920}
					height={2100}
					source={{ type: "webp", src: berriesImageXl }}
					sourcesets={{
						">sm": berriesImageSm,
						">md": berriesImageMd,
						">lg": berriesImageLg,
						">xl": berriesImageXl,
					}}
					alt={translate("berriesImageAlt")}
					wrapperClass="overflow-hidden absolute inset-0"
					class="absolute block inset-0 size-full object-cover"
				/>
			</div>
		</div>
	</section>
</Layout>
